<nav hlmNavigationMenu>
  <ul hlmNavigationMenuList>
    <li hlmNavigationMenuItem>
      <a hlmNavigationMenuLink routerLink="/dashboard/rf-wizard">Upload</a>
    </li>
    @if (canViewMappings()) {
      <li hlmNavigationMenuItem>
        <a hlmNavigationMenuLink routerLink="/dashboard/mappings">Mappings</a>
      </li>
    }
    <li hlmNavigationMenuItem>
      <a hlmNavigationMenuLink routerLink="/dashboard/submissions">Submissions</a>
    </li>
    @if (canViewParticipants()) {
      <li hlmNavigationMenuItem>
        <a hlmNavigationMenuLink routerLink="/dashboard/participants">Participants</a>
      </li>
    }
    @if (canViewReporting()) {
      <li hlmNavigationMenuItem>
        <a hlmNavigationMenuLink routerLink="/dashboard/reporting">Reporting</a>
      </li>
    }
    @if (permissionService.isAdmin()) {
      <li hlmNavigationMenuItem>
        <a hlmNavigationMenuLink routerLink="/admin/users">Admin</a>
      </li>
    }
  </ul>
</nav>
